import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LandingDemo from '../components/LandingDemo';
import { applyMeta, landingMeta } from '../seo.js';

export default function Landing() {
  // The prerenderer emits these same tags into the static HTML from the same
  // descriptor; this keeps them correct on client-side navigation.
  useEffect(() => applyMeta(landingMeta()), []);

  return (
    <div className="landing">
      <section className="landing__hero">
        <h1 className="landing__title">Who really runs the show?</h1>
      </section>

      <section className="landing__story">
        <h2>Why I built this</h2>
        <p>
          I'm a massive Joe Rogan fan. I listen to about three or four episodes a week, to
          the point where I can practically finish his sentences. I know the exact moment
          he's about to bring up cold plunges, sauna heat shock proteins, the government
          or high-altitude hunting.
        </p>
        <p>
          Because of that, my favourite episodes are the ones where Joe steps back and lets
          the guest completely run the show. The problem is that you usually have to listen
          to the whole episode to find out.
        </p>
        <p>
          So I created TalkMuch. It measures the talk-time split for every episode, so I can
          spot the guest-heavy ones before hitting play.
        </p>
      </section>

      <section className="landing-demo-section" id="how-to-read">
        <h2>How to read an episode</h2>
        <p>
          Every episode on the site gets a stat block like this one. Here is what each
          number tells you.
        </p>
        <LandingDemo />
      </section>

      <section className="landing__cta">
        <Link to="/podcasts" className="btn btn--primary">Browse the podcasts</Link>
        <Link to="/leaderboard" className="btn btn--ghost landing__cta-secondary">See the leaderboard</Link>
      </section>
    </div>
  );
}
